<template>
  <div>
    <div style="height:94%;padding: 0 5% 50px 5%;">
        <iframe
         style="border:none;width:100%;height:100%;"
         v-bind:src="reportUrl"
       ></iframe>
    </div>
  </div>
</template>

<script>
import { getData, myInfo, getKvList } from '@/utils/request'

export default {
  name: 'GROUP_REPORT_MONTH',
  data () {
    return {
        reportUrl: '',
        groupName: []
    }
  },
  created () {
  },
  mounted () {
    this.GroupComponent()
  },
  methods: {
    GroupComponent () {
        getData('curGroup').then(response => {
            myInfo().then(res => {
              getKvList('Shop').then(resp => {
                var Ids = ''
                for (var item of resp.data) {
                    Ids += item.id + "','"
                }
                Ids = Ids.slice(0, Ids.length - 3)
                // var jtname = response.data.name
                // var loginUser = res.data.user.account
                // var UrlComponent = 'jt/' + jtname + '-集团月报表'
                // UrlComponent = encodeURIComponent(UrlComponent)
                // this.reportUrl = 'https://www.cdseku.com/webroot/decision/view/report?viewlet=' + UrlComponent +
                // '.cpt&op=view&fine_username=' + loginUser + '&fine_password=kpi123456'
                // console.log(this.reportUrl)
                // this.reportUrl = 'https://fr.miaomaicar.com/webroot/decision/view/report?viewlet=PPG/%E9%87%8D%E5%BA%86%E4%B8%87%E5%8F%8B%E9%9B%86%E5%9B%A2-%E9%9B%86%E5%9B%A2%E6%9C%88%E6%8A%A5%E8%A1%A8.cpt&ref_t=design&op=view&ref_c=3a37a6b8-bf8b-49ae-b545-afff6d1dbb86'
                this.reportUrl = 'https://fr.miaomaicar.com/webroot/decision/view/report?viewlet=PPG/集团月报表.cpt&ref_t=design&op=view&shop_code=' +
                Ids + '&root_db=' + this.ReportConfig.VUE_ROOT_DB + '&group_db=' + this.ReportConfig.VUE_GROUP_DB + '&shop_db=' + this.ReportConfig.VUE_SHOP_DB
                console.log(this.reportUrl)
              })
            })
        })
    }
  },
  computed: {
  }
}
</script>
